import { render, staticRenderFns } from "./MaterialsViewDialog.vue?vue&type=template&id=1346afb2&scoped=true"
import script from "./MaterialsViewDialog.vue?vue&type=script&lang=js"
export * from "./MaterialsViewDialog.vue?vue&type=script&lang=js"
import style0 from "./MaterialsViewDialog.vue?vue&type=style&index=0&id=1346afb2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1346afb2",
  null
  
)

export default component.exports